import React from "react";
import Styles from "./HeaderBreadCrumb.module.css";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { useHistory } from "react-router-dom";

const HeaderBreadCrumb = () => {
	const history = useHistory();

	function handleClick(path) {
		console.info("You clicked a breadcrumb.", path);
		history.push(path);
	}

	return (
		<div className={Styles["HeaderBreadCrumb"]}>
			<Breadcrumbs
				separator="&#8212;"
				aria-label="breadcrumb"
				className={Styles["Breadcrumb-space"]}
			>
				{/* <Link
					className={`${Styles["Breadcrumb-text"]} ${Styles["Breadcrumb-underline"]}`}
					href="/"
					onClick={handleClick}
				>
					Meus cursos
				</Link>
				<Link
					className={`${Styles["Breadcrumb-text"]} ${Styles["Breadcrumb-underline"]}`}
					href="/"
					onClick={handleClick}
				>
					Detalhes do curso
				</Link>
				<Link
					className={`${Styles["Breadcrumb-text"]} ${Styles["last-breadcrumb"]}`}
					href="/"
					onClick={handleClick}
				>
					Detalhes da acção
				</Link> */}
				<Link
					className={`${Styles["Breadcrumb-text"]} ${Styles["Breadcrumb-underline"]}`}
					style={{"cursor":"pointer"}}
					onClick={handleClick.bind(
						null,
						"/formacao/catalog"
					)}
				>
					Catálogo
				</Link>
				<Link
					className={`${Styles["Breadcrumb-text"]} ${Styles["last-breadcrumb"]}`}
				>
					Detalhes do Curso
				</Link>
			</Breadcrumbs>
		</div>
	);
};

export default HeaderBreadCrumb;
